export type IconName =
  | "arrow-down"
  | "arrow-right"
  | "arrow-up"
  | "bars"
  | "bell"
  | "bold"
  | "calendar"
  | "chevron-down"
  | "chevron-left"
  | "chevron-right"
  | "chevron-up"
  | "circle"
  | "circle-check"
  | "circle-info"
  | "circle-question"
  | "circle-xmark"
  | "clock"
  | "clock-rotate-left"
  | "comment"
  | "download"
  | "dollar-sign"
  | "ellipsis"
  | "ellipsis-vertical"
  | "envelope"
  | "expand"
  | "eye"
  | "eye-slash"
  | "gear"
  | "grip-lines"
  | "heading"
  | "image"
  | "italic"
  | "minus"
  | "left-right"
  | "link"
  | "list"
  | "location-dot"
  | "magnifying-glass"
  | "maximize"
  | "paw"
  | "phone"
  | "plus"
  | "star"
  | "sliders"
  | "trash"
  | "triangle-exclamation"
  | "underline"
  | "up-down"
  | "user"
  | "x"
  | "xmark";

type IconProps = {
  name: IconName;
  className?: string;
  "aria-label"?: string;
};

export default function Icon({
  name,
  className = "",
  "aria-label": ariaLabel,
}: IconProps) {
  return (
    <i className={`${className} fa-solid fa-${name}`} aria-label={ariaLabel} />
  );
}
